import { useContext } from 'react';

import type { IUseAuth } from './IUseAuth';
import { AuthContext } from './context';

export function useAuth(): IUseAuth {
  const context = useContext(AuthContext);
  return context;
}
